import {
  ButtonGroup,
  DateSelectField,
  Grid,
  GridItem,
  PrimaryButton,
} from "@certn/cascadia-react";
import { Field, Form, Formik } from "formik";
import { useTranslation } from "react-i18next";
import { date, object } from "yup";

import { AddressInput, addressSchema, initialValues } from "./AddressInput";

export function AddressForm(props: any) {
  const { handleSubmit, userInformation, testID = "address-form" } = props;
  const { t } = useTranslation();

  return (
    <Formik
      initialValues={
        userInformation?.personal_profile?.profile_addresses[0]
          ? userInformation?.personal_profile?.profile_addresses[0]
          : { ...initialValues, start_date: null }
      }
      onSubmit={handleSubmit}
      validationSchema={addressSchema.concat(
        object().shape({
          start_date: date().required().label(t("Start date")),
        })
      )}
    >
      {() => (
        <Form>
          <Grid width="416px">
            <AddressInput />
            <GridItem>
              <Field
                label={t("Start date")}
                name="start_date"
                isApproximateDate
                isRequired
                fullWidth
                formatOverride="mm-yy"
                as={DateSelectField}
              />
            </GridItem>
            <GridItem>
              <ButtonGroup>
                <PrimaryButton
                  type="submit"
                  size="medium"
                  testID={`${testID}-save-button`}
                >
                  {t("Save")}
                </PrimaryButton>
              </ButtonGroup>
            </GridItem>
          </Grid>
        </Form>
      )}
    </Formik>
  );
}
